// @ts-nocheck
/**
 * Attempts to parse a JSON string and returns the parsed object or undefined if parsing fails.
 * @param jsonString The JSON string to parse.
 * @returns JSON object if parsing is successful, "undefined" if it fails.
 */
const tryJsonParse = <T = any>(jsonString: string | undefined): T | undefined => {
    if (!jsonString) {
        return undefined;
    }

    try {
        return JSON.parse(jsonString) as T;
    } catch {
        return undefined;
    }
};

export default tryJsonParse;
